import React from 'react';
import { IconProps } from './typing';

const Pencil = ({
  iconSize = 12,
  background = 'none',
  color = 'currentColor',
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
  >
    <path
      d="M8.739 0.418823L11.403 4.08382L5.311 8.70982C4.98489 8.9562 4.58771 9.09023 4.179 9.09182H0.648L1.984 5.79782C2.11276 5.48092 2.32579 5.2053 2.6 5.00082L8.739 0.418823ZM8.456 2.28982L3.394 6.06782C3.31449 6.12668 3.25315 6.20674 3.217 6.29882L2.623 7.76182H4.179C4.29749 7.76145 4.41263 7.72248 4.507 7.65082L9.561 3.81282L8.456 2.28982ZM11.5 11.5811V10.2511H0.5V11.5811H11.5Z"
      fill={color}
    />
  </svg>
);

export default Pencil;
